export default __webpack_public_path__ + "static/media/add.f6ff7ffd.svg";